import ND from '../assets/img/parties/ND.png';
import SYRIZA from '../assets/img/parties/SYRIZA.png';
import PASOK from '../assets/img/parties/PASOK.png';
import KKE from '../assets/img/parties/KKE.png';
import EL from '../assets/img/parties/EL.png';
import SPARTIATES from '../assets/img/parties/SPARTIATES.png';
import NIKI from '../assets/img/parties/NIKI.png';
import PE from '../assets/img/parties/PE.png';
import MeRA25 from '../assets/img/parties/MeRA25.png';
import FL from '../assets/img/parties/FL.png';
import NA from '../assets/img/parties/NA.png';
import KD from '../assets/img/parties/KD.png';
import ANTARSYA from '../assets/img/parties/ANTARSYA.png';
import EK from '../assets/img/parties/EK.png';
import KKEML from '../assets/img/parties/KKE M-L.png';
import XA from '../assets/img/parties/XA.png';

const parties = [
    {
        "name": "Νέα Δημοκρατία (ΝΔ)",
        "desc": "Φιλελεύθερο συντηρητικό κόμμα που ιδρύθηκε το 1974. Έχει μακρά κυβερνητική παρουσία και στηρίζεται κυρίως από μεσαία και ανώτερα κοινωνικά στρώματα, ιδιαίτερα μεγαλύτερων ηλικιών.",
        "img": ND,
        "style": { "width": "80px", "height": "60px" },
        "stats": { "a": 60, "b": 65, "c": 60, "d": 62.5, "e": 50, "f": 35, "g": 60 }
    },
    {
        "name": "Συνασπισμός Ριζοσπαστικής Αριστεράς (ΣΥΡΙΖΑ)",
        "desc": "Προοδευτικό κόμμα που εξελίχθηκε από συμμαχία της αριστεράς. Κυβέρνησε το διάστημα 2015–2019. Η βάση του περιλαμβάνει κυρίως νέους και αστικά στρώματα, αν και έχει συρρικνωθεί λόγω διασπάσεων τα τελευταία χρόνια.",
        "img": SYRIZA,
        "style": { "width": "80px", "height": "40px" },
        "stats": { "a": 15, "b": 35, "c": 35, "d": 20, "e": 70, "f": 25, "g": 20 }
    },
    {
        "name": "Πανελλήνιο Σοσιαλιστικό Κίνημα (ΠΑΣΟΚ)",
        "desc": "Σοσιαλδημοκρατικό κόμμα, ιδρυμένο το 1974 και γνωστό για την ισχυρή παρουσία του τη δεκαετία του 1980. Από το 2019 παρουσιάζει σταδιακή ανάκαμψη, αν και παραμένει δημοφιλές κυρίως σε μεγαλύτερες ηλικίες.",
        "img": PASOK,
        "style": { "width": "80px", "height": "60px" },
        "stats": { "a": 30, "b": 40, "c": 55, "d": 55, "e": 70, "f": 30, "g": 45 }
    },
    {
        "name": "Κομμουνιστικό Κόμμα Ελλάδας (KKE)",
        "desc": "Κομμουνιστικό κόμμα, το αρχαιότερο εν ενεργεία στην Ελλάδα (από το 1918). Σταθερή εκλογική βάση με δράση σε εργατικά και φοιτητικά κινήματα. Απέχει από κυβερνητικούς συνασπισμούς με εξαίρεση το 1989.",
        "img": KKE,
        "style": { "width": "80px", "height": "60px" },
        "stats": { "a": 25, "b": 5, "c": 95, "d": 5, "e": 55, "f": 25, "g": 15 }
    },
    {
        "name": "Ελληνική Λύση (EΛ)",
        "desc": "Κόμμα εθνικού συντηρητικού προσανατολισμού που ιδρύθηκε το 2016. Ενισχύθηκε ιδιαίτερα μετά τη συμφωνία των Πρεσπών και έχει στήριξη κυρίως σε περιοχές της Μακεδονίας.",
        "img": EL,
        "style": { "width": "80px", "height": "35px" },
        "stats": { "a": 85, "b": 55, "c": 75, "d": 85, "e": 25, "f": 70, "g": 90 }
    },
    {
        "name": "Σπαρτιάτες",
        "desc": "Εθνικιστικό κόμμα ιδρυμένο το 2017. Απέκτησε προσωρινή εκλογική δυναμική το 2023 λόγω στήριξης από πρώην κύκλους της Χρυσής Αυγής, την οποία απώλεσε λόγω εσωτερικών συγκρούσεων.",
        "img": SPARTIATES,
        "style": { "width": "80px", "height": "80px" },
        "stats": { "a": 82.5, "b": 60, "c": 70, "d": 85, "e": 25, "f": 80, "g": 90 }
    },
    {
        "name": "Νίκη (ΝΙΚΗ)",
        "desc": "Χριστιανοδημοκρατικό κόμμα που ιδρύθηκε το 2019. Απευθύνεται σε παραδοσιακούς και θρησκευόμενους ψηφοφόρους.",
        "img": NIKI,
        "style": { "width": "80px", "height": "80px" },
        "stats": { "a": 90, "b": 50, "c": 70, "d": 100, "e": 35, "f": 70, "g": 85 }
    },
    {
        "name": "Πλεύση Ελευθερίας (ΠΕ)",
        "desc": "Κόμμα αριστερής και αντιμνημονιακής κατεύθυνσης, ιδρυμένο το 2016. Ανέβηκε στη δημοσιότητα μετά την τραγωδία στα Τέμπη, με στήριξη από νεότερες ηλικίες.",
        "img": PE,
        "style": { "width": "65px", "height": "80px" },
        "stats": { "a": 20, "b": 25, "c": 30, "d": 20, "e": 70, "f": 60, "g": 30 }
    },
    {
        "name": "Μέτωπο Ευρωπαϊκής Ρεαλιστικής Avuπακoής 25 (ΜέΡA25)",
        "desc": "Αριστερό, διεθνιστικό κόμμα που ιδρύθηκε το 2018. Υποστηρίζει προοδευτική κοινωνική πολιτική και ισχυρό κράτος πρόνοιας. Προσελκύει ψηφοφόρους παρόμοιους με αυτούς του ΣΥΡΙΖΑ.",
        "img": MeRA25,
        "style": { "width": "80px", "height": "40px" },
        "stats": { "a": 5, "b": 25, "c": 20, "d": 10, "e": 85, "f": 20, "g": 10 }
    },
    {
        "name": "Φωνή Λογικής",
        "desc": "Συντηρητικό κόμμα που προέκυψε το 2023 από διάσπαση της Νέας Δημοκρατίας. Προσεγγίζει πρώην συντηρητικούς ψηφοφόρους του κυβερνητικού κόμματος.",
        "img": FL,
        "style": { "width": "65px", "height": "80px" },
        "stats": { "a": 70, "b": 75, "c": 65, "d": 70, "e": 35, "f": 40, "g": 75 }
    },
    {
        "name": "Νέα Αριστερά",
        "desc": "Κόμμα του προοδευτικού χώρου που ιδρύθηκε το 2023 από αποχωρήσαντες του ΣΥΡΙΖΑ. Απευθύνεται σε ψηφοφόρους του κέντρου και της αριστεράς.",
        "img": NA,
        "style": { "width": "80px", "height": "35px" },
        "stats": { "a": 15, "b": 35, "c": 30, "d": 17.5, "e": 72.5, "f": 15, "g": 25 }
    },
    {
        "name": "Κίνημα Δημοκρατίας (ΚΔ)",
        "desc": "Νέο προοδευτικό κόμμα, αποτέλεσμα διάσπασης από τον ΣΥΡΙΖΑ το 2024. Σκοπεύει στην εκλογική βάση του ΣΥΡΙΖΑ και του ΠΑΣΟΚ.",
        "img": KD,
        "style": { "width": "80px", "height": "35px" },
        "stats": { "a": 15, "b": 35, "c": 30, "d": 15, "e": 70, "f": 15, "g": 25 }
    },
    {
        "name": "Αντικαπιταλιστική Αριστερή Συνεργασία για την Ανατροπή (ANTAPΣYA)",
        "desc": "Αντικαπιταλιστικός συνασπισμός της εξωκοινοβουλευτικής αριστεράς, ιδρυμένος το 2009. Δρα κυρίως σε φοιτητικούς και συνδικαλιστικούς χώρους. Κινείται σταθερά κάτω του 1%.",
        "img": ANTARSYA,
        "style": { "width": "80px", "height": "35px" },
        "stats": { "a": 0, "b": 0, "c": 10, "d": 0, "e": 90, "f": 45, "g": 0 }
    },
    {
        "name": "Ένωση Κεντρώων (EK)",
        "desc": "Κεντρώο κόμμα ιδρυμένο το 1992. Μπήκε στη Βουλή το 2015 αλλά αντιμετώπισε εσωτερικές συγκρούσεις και έχει πλέον περιορισμένη επιρροή. Υποστηρίζει φιλελεύθερες θέσεις σε οικονομικά και κοινωνικά ζητήματα.",
        "img": EK,
        "style": { "width": "80px", "height": "80px" },
        "stats": { "a": 45, "b": 52.5, "c": 55, "d": 65, "e": 60, "f": 35, "g": 77.5 }
    },
    {
        "name": "Κομμουνιστικό Κόμμα Ελλάδας (Μαρξιστικό–Λενινιστικό) (KKE μ-λ)",
        "desc": "Μαοϊκό κόμμα που ιδρύθηκε το 1976. Δραστηριοποιείται κυρίως στον συνδικαλισμό και το φοιτητικό κίνημα, ενώ καταγράφει σταθερά ποσοστά κάτω του 1%.",
        "img": KKEML,
        "style": { "width": "80px", "height": "30px" },
        "stats": { "a": 5, "b": 0, "c": 95, "d": 0, "e": 72.5, "f": 67.5, "g": 15 }
    },
    {
        "name": "Χρυσή Αυγή (XA)",
        "desc": "Εθνικιστικό κόμμα με εθνικοσοσιαλιστικές θέσεις. Ιδρύθηκε το 1983 και κατέγραψε υψηλά ποσοστά την περίοδο της κρίσης. Το 2020 καταδικάστηκε ως εγκληματική οργάνωση αλλά διατηρεί εξωκοινοβουλευτική δράση.",
        "img": XA,
        "style": { "width": "65px", "height": "80px" },
        "stats": { "a": 100, "b": 0, "c": 100, "d": 90, "e": 10, "f": 100, "g": 100 }
    }
];

export default parties;